/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetEnvironmentReleasePlansPathParams = NonNullable<
  operations['GetEnvironmentReleasePlans']['parameters']['path']
>;

export type GetEnvironmentReleasePlansQueryParams = NonNullable<
  operations['GetEnvironmentReleasePlans']['parameters']['query']
>;

export interface Input extends GetEnvironmentReleasePlansPathParams {
  apiVersion?: string;
  query?: GetEnvironmentReleasePlansQueryParams;
  header: NonNullable<operations['GetEnvironmentReleasePlans']['parameters']['header']>;
}

export async function GetEnvironmentReleasePlans(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/release-plans', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
